<template>
  <div class="graduates-content">
    <div class="image-section">
      <div class="description">
        <p style="text-indent:2em;">东亚同文书院创立于1900年，由日本"东亚同文会"在上海设立(最初设立于南京)，旨在培养通晓中国语言、历史地理与经贸实务的对华人才。书院以严格的中文训练和长期的"大旅行调查"著称，学生足迹遍及中国各地。自创办至1945年停办，累计培养学生5000人左右。其毕业生多进入日本在华商社、外务省系统、满铁、报社等，成为对华政策、经济活动与情报工作的关键人力；亦有部分投身学术与出版等，参与中日文化交流。</p>
        <br>
        <p style="text-indent:2em;">本数据库由西南大学"近代日本对华调查活动研究"团队依据公开档案、校史、报刊与回忆录等资料整理而成。为便于核验与延伸研究，每一条目均标注文献来源，对存疑信息做备注说明。欢迎学界同仁批评指正。</p>


      </div>
    </div>

    <!-- 搜索区域 -->
    <div class="search-section">
      <div class="search-header">
        <h3 class="search-title">毕业生查询</h3>
      </div>
      <div class="search-form">
        <div class="form-group">
          <label for="name">姓名</label>
          <input type="text" id="name" v-model="searchParams.name" class="form-control" placeholder="输入姓名">
        </div>
        <div class="form-group">
          <label for="period">期别</label>
          <select id="period" v-model="searchParams.period" class="form-control">
            <option value="">全部期别</option>
            <option v-for="period in periods" :key="period" :value="period">{{ period }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="major">专业</label>
          <select id="major" v-model="searchParams.major" class="form-control">
            <option value="">全部专业</option>
            <option v-for="major in majors" :key="major" :value="major">{{ major }}</option>
          </select>
        </div>
        <div class="form-group">
          <label for="origin">原籍</label>
          <input type="text" id="origin" v-model="searchParams.origin" class="form-control" placeholder="输入原籍(省/县/都道府县)">
        </div>
        <div class="search-actions">
          <button type="button" class="btn btn-secondary" @click="resetSearch">重置</button>
        </div>
      </div>
    </div>

    <!-- 表格组件 -->
    <GraduatesTable
        :search-params="searchParams"
        :periods="periods"
        :majors="majors"
        @show-detail="showDetail"
    />
  </div>
</template>

<script>
import {ref, reactive, onMounted, inject, watch} from 'vue'
import api from '@/services/api'
import GraduatesTable from '@/components/GraduatesTable.vue'
import { debounce } from 'lodash-es'

export default {
  name: 'Graduates',
  components: {
    GraduatesTable
  },
  setup() {
    const showModal = inject('showModal')

    // 搜索参数
    const searchParams = reactive({
      name: '',
      period: '',
      major: '',
      origin: '',
      pageNum: 1
    })

    // 立即执行的防抖函数，用于处理页码重置
    const debouncedSearch = debounce((newVal, oldVal) => {
      // 只有当实际搜索条件变化时才重置页码
      const { pageNum: newPageNum, ...newSearch } = newVal
      const { pageNum: oldPageNum, ...oldSearch } = oldVal || {}

      if (JSON.stringify(newSearch) !== JSON.stringify(oldSearch)) {
        searchParams.pageNum = 1
      }
    }, 500)

    watch(
        () => ({ ...searchParams }),
        debouncedSearch,
        { deep: true }
    )

    // 选项数据
    const periods = ref([])
    const majors = ref([])

    const getPeriodsOption = async () => {
      try {
        const response = await api.getOption("period")
        periods.value = response.data.data || []
      } catch (error) {
        console.error('获取期别数据失败:', error)
        periods.value = []
      }
    }

    const getMajorsOption = async () => {
      try {
        const response = await api.getOption("major")
        majors.value = response.data.data || []
      } catch (error) {
        console.error('获取专业数据失败:', error)
        majors.value = []
      }
    }

    // 重置搜索
    const resetSearch = () => {
      searchParams.name = ''
      searchParams.period = ''
      searchParams.major = ''
      searchParams.origin = ''
      searchParams.pageNum = 1
    }

    // 添加防抖watch
    watch(() => ({ ...searchParams }), debounce(() => {
      searchParams.pageNum = 1 // 任何搜索条件变化都重置到第一页
    }, 500), { deep: true })

    // 显示详情（保持不变）
    const showDetail = async (id) => {
      try {
        const response = await api.getGraduateDetail(id)
        const graduate = response.data.data

        const detailContent = `
          <p><strong>专业：</strong>${graduate.major || '无'}</p>
          <p><strong>期别：</strong>${graduate.period || '无'}</p>
          <p><strong>原籍：</strong>${graduate.origin || '无'}</p>
          <p><strong>主要经历：</strong></p>
          <p>${graduate.detail || '无记录'}</p>
          <p><strong>备注：</strong></p>
          <p>${graduate.remarks || '无'}</p>
        `

        showModal(`${graduate.name || '未知'} 详细信息`, detailContent)
      } catch (error) {
        console.error('获取毕业生详情失败:', error)
        showModal('错误', '获取详情失败，请稍后再试')
      }
    }

    // 初始化加载数据
    onMounted(() => {
      getPeriodsOption()
      getMajorsOption()
    })

    return {
      searchParams,
      periods,
      majors,
      resetSearch,
      showDetail
    }
  }
}
</script>

<style scoped>
.graduates-content {
  width: 100%;
}

.image-section {
  margin-bottom: clamp(20px, 3vw, 30px);
  text-align: center;
}

.description {
  margin: clamp(15px, 2vw, 20px) 0;
  line-height: 1.6;
  color: var(--secondary-color);
  font-size: clamp(0.9rem, 1.8vw, 1rem);
  text-align: left;
  font-family: Arial, sans-serif;
  margin: 20px;
}

.search-section {
  background-color: var(--light-gray);
  padding: clamp(15px, 3vw, 25px);
  border-radius: var(--border-radius);
  margin-bottom: clamp(20px, 3vw, 30px);
  box-shadow: var(--box-shadow);
}

.search-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: clamp(15px, 2vw, 20px);
}

.search-title {
  font-size: clamp(1.1rem, 2.5vw, 1.3rem);
  color: var(--primary-color);
  margin: 0;
}

.search-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: clamp(10px, 2vw, 20px);
}

.form-group {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: var(--secondary-color);
  font-size: clamp(0.85rem, 1.8vw, 0.95rem);
}

.form-control {
  width: 100%;
  padding: clamp(10px, 1.5vw, 12px) clamp(12px, 1.5vw, 15px);
  border: 1px solid var(--medium-gray);
  border-radius: var(--border-radius);
  transition: var(--transition);
  font-size: clamp(0.85rem, 1.8vw, 0.95rem);
  background-color: var(--white);
}

.form-control:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(211, 47, 47, 0.2);
}

.search-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: clamp(10px, 2vw, 15px);
  margin-top: clamp(15px, 2vw, 20px);
  grid-column: 1 / -1;
  border-top: 1px solid var(--medium-gray);
  padding-top: clamp(15px, 2vw, 20px);
}

.btn {
  padding: clamp(8px, 1.5vw, 10px) clamp(15px, 2vw, 20px);
  border: none;
  border-radius: var(--border-radius);
  cursor: pointer;
  transition: var(--transition);
  font-weight: 500;
  font-size: clamp(0.85rem, 1.8vw, 0.95rem);
}

.btn-primary {
  background-color: var(--primary-dark);
  color: var(--white);
}

.btn-primary:hover {
  background-color: var(--primary-color);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.btn-secondary {
  background-color: var(--medium-gray);
  color: var(--dark-gray);
}

.btn-secondary:hover {
  background-color: #d5d5d5;
}

@media (max-width: 992px) {
  .search-form {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .search-form {
    grid-template-columns: 1fr;
  }
}
</style>